import { render, staticRenderFns } from "./createform.vue?vue&type=template&id=5264ec81&scoped=true"
import script from "./createform.vue?vue&type=script&lang=js"
export * from "./createform.vue?vue&type=script&lang=js"
import style0 from "./createform.vue?vue&type=style&index=0&id=5264ec81&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5264ec81",
  null
  
)

export default component.exports